import { useMemo } from 'react';
import { ApiConfigurationProvider as Provider } from '@portfolio-manager/query';
import type { ConfigurationParameters } from '@portfolio-manager/sdk';
import { useAuthService } from './auth-service-provider';

export interface ApiConfigurationProviderProps extends React.PropsWithChildren {}

export function ApiConfigurationProvider({ children }: ApiConfigurationProviderProps): React.ReactElement {
  const { getAccessToken } = useAuthService();

  const configuration: ConfigurationParameters = useMemo(
    () => ({ accessToken: () => getAccessToken() ?? '' }),
    [getAccessToken],
  );

  return <Provider configuration={configuration}>{children}</Provider>;
}
